import { CANCEL_EVENT, SHOW_EVENT, SUCCESS_EVENT } from './constants';
import type {
	TransitionScreenShowEvent,
	TransitionScreenCancelEvent,
	TransitionScreenSuccessEvent,
} from './types';

export const transitionScreenDialogShow = (): TransitionScreenShowEvent => ({
	type: SHOW_EVENT,
});

export const transitionScreenDialogSuccess = (): TransitionScreenSuccessEvent => ({
	type: SUCCESS_EVENT,
});

export const transitionScreenDialogCancel = (): TransitionScreenCancelEvent => ({
	type: CANCEL_EVENT,
});
